import httpClient from '@/http-client'
export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const department = (Options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances/departments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const position = (Options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances/positions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const header = (Options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances/headers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const holiday = (Options = {}) => {
  return httpClient
    .get('/api/v1/monthly-attendances/holidays', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  department,
  employee,
  position,
  header,
  get,
  holiday
}